import { doc, setDoc } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";

const DeleteIncome = async (IncomeId) => {
  try {
    const IncomeRef = doc(db, "Incomes", IncomeId);

    await setDoc(
      IncomeRef,
      {
        IsDeleted: true,
      },
      { merge: true }
    );
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteIncome;
